import { FC } from "react";

import { Box } from "@chakra-ui/react";

const ExpandContent: FC<{ children?: any }> = ({ children }) => (
  <Box bg="grey.light" px="1rem" pt="0.5rem" pb="1rem">
    {children}
  </Box>
);
export default ExpandContent;
